module.exports = __webpack_public_path__ + "img/blackshepherdsfinal_koln.bc90ece4.jpg";